import React, { FC } from 'react';

import { useIsAiChatbot } from '../../../common/hooks/useIsAiChatbot';
import { IBotTyping } from '../../../common/messageCreators';
import { BotTypingAI } from './BotTypingAI';
import { BotTypingClassic } from './BotTypingClassic';

export const BotTyping: FC<IBotTyping> = (props) => {
  const isAiChatbot = useIsAiChatbot();

  return isAiChatbot ? <BotTypingAI {...props} /> : <BotTypingClassic {...props} />;
};
